import { Route } from 'react-router-dom';

import { UserDetailPage } from './pages/user-detail-page.js';
import { UserFormPage } from './pages/user-form-page.js';
import { UserListPage } from './pages/user-list-page.js';

export function userRoutes(): React.JSX.Element {
  return (
    <>
      <Route path="/users" element={<UserListPage />} />
      <Route path="/users/new" element={<UserFormPage />} />
      <Route path="/users/:userId/edit" element={<UserFormPage />} />
      <Route path="/users/:userId" element={<UserDetailPage />} />
    </>
  );
}
